// ------------------
// MQTT Topics
// ------------------
// This will provide location data to the GUI
export const TOPIC_INFO = 'v1/localization/info';

// Create and delete robot objects
export const TOPIC_CREATE = 'v1/robot/create';
export const TOPIC_DELETE = 'v1/robot/delete';
